import { Button, Card, Dialog, DialogActions, DialogContent, Grid2 } from '@mui/material'
import { withStyles } from '@mui/styles'
import SieauParameterDto from 'administration/dto/SieauParameterDto'
import { CardTable } from 'components/datatable/NewTable'
import Input from 'components/forms/Input'
import SimpleDatePicker from 'components/forms/SimpleDatePicker'
import Icon from 'components/icon/Icon'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import ExportAction from 'export/actions/ExportAction'
import { orderBy } from 'lodash'
import DtoVariousMaterielSituation from 'materiel/components/variousMateriel/dto/DtoVariousMaterielSituation'
import DtoVariousMaterielType from 'materiel/components/variousMateriel/dto/DtoVariousMaterielType'
import VariousMaterielDto from 'materiel/components/variousMateriel/dto/VariousMaterielDto'
import DtoMaterielChronicle from 'materiel/dto/DtoMaterielChronicle'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { nbPerPageLabelTiny } from 'referencial/constants/ReferencialConstants'
import DtoSandreCode from 'referencial/dto/DtoSandreCode'
import i18n from 'simple-react-i18n'
import ToastrAction from 'toastr/actions/ToastrAction'
import { darkBlue, secondaryBlue } from 'utils/constants/ColorTheme'
import { getDate } from 'utils/DateUtil'
import { formatData } from 'utils/ExportDataUtil'
import { getSetting } from 'utils/SettingUtils'
import { formatMilliers, getSandreLabel } from 'utils/StringUtil'

const styles = () => ({
    card: {
        padding: '8px',
        height: '100%',
    },
    selected: {
        padding: '8px',
        backgroundColor: `${secondaryBlue} !important`,
        color: 'white !important',
        height: '100%',
    },
    item: {
        padding: '4px !important',
    },
})

const headersEstim = ['nullValue2', 'startDate', 'endDate', 'estimateM3']
const headersIndex = ['nullValue2', 'statementDate', 'nullValue', 'index']

const STEP_MATERIEL = 0
const STEP_TYPE = 1
const STEP_CHRONICLE = 2

const TYPE_ESTIM = 1
const TYPE_INDEX = 2

class AddConsoModal extends Component {
    constructor(props) {
        super(props)
        const allMaterialsIds = [...(props.pumpsIds || []), ...(props.countersIds || [])]
        this.state = {
            chronicles: props.chronicles || [],
            pumpsIds: props.pumpsIds || [],
            countersIds: props.countersIds || [],
            consoType: props.consoType,
            step: props.selectedMaterial ? STEP_CHRONICLE : STEP_MATERIEL,
            errors: [],
            selectedMaterial: props.selectedMaterial || (allMaterialsIds.length === 1 ? allMaterialsIds[0] : null),
            measureDate: null,
            endDate: null,
            value: null,
        }
    }

    previousStep = () => {
        const { step } = this.state
        this.setState({ step: step - 1 })
    }

    nextStep = () => {
        const { step } = this.state
        if (this.checkStep(step)) {
            this.setState({ step: step + 1 })
        }
    }

    checkStep = (step) => {
        const { selectedMaterial, consoType } = this.state
        if (step === STEP_TYPE && consoType === TYPE_ESTIM) {
            this.props.warning(i18n.entryEstimateWarning)
            return true
        }
        if (step === STEP_MATERIEL && !selectedMaterial) {
            ToastrAction.error(i18n.pleaseSelectEquipment)
            return false
        }
        return true
    }

    setSelectedMat = (materiel) => {
        const materielsTypeForIndex = getSetting(this.props.applicationSettings, 'materielsTypeForIndex')?.split(',').map((id) => Number(id)) || []
        this.setState({
            selectedMaterial: materiel.id,
            consoType: materielsTypeForIndex?.includes(materiel.materielType) ? TYPE_INDEX : TYPE_ESTIM,
            measureDate: null,
            endDate: null,
            value: null,
        })
    }

    getCounterCard = (compteurInfos) => {
        const { classes, variousMaterielTypes } = this.props
        const { selectedMaterial } = this.state
        const counterType = variousMaterielTypes.find((t) => t.materielType === compteurInfos.materielType)
        return (
            <Grid2 size={3} className='clickable' sx={{ margin: '5px 0' }} onClick={() => this.setSelectedMat(compteurInfos)}>
                <Card className={selectedMaterial === compteurInfos.id ? classes.selected : classes.card}>
                    <Grid2 container>
                        <Grid2 size={12} className='bold'>{i18n.id} : {compteurInfos.reference || ''}</Grid2>
                        <Grid2 size={12} className='margin-bottom-1'>
                            <span className='bold'>{i18n.name} : </span><span>{compteurInfos?.name || ''}</span>
                        </Grid2>
                        <Grid2 size={12}>
                            <span className='bold'>{i18n.type} : </span><span>{counterType ? counterType.name : ''}</span>
                        </Grid2>
                        <Grid2 size={12}>
                            <span className='bold'>{i18n.readingCoefficient} : </span><span>{compteurInfos.readingCoefficient || ''}</span>
                        </Grid2>
                        <Grid2 size={12}>
                            <span className='bold'>{i18n.brand} : </span><span>{compteurInfos.brand || ''}</span>
                        </Grid2>
                        <Grid2 size={12}>
                            <span className='bold'>{i18n.installationDate} : </span><span>{getDate(compteurInfos.installationDate) || ''}</span>
                        </Grid2>
                        <Grid2 size={12}>
                            <span className='bold'>{i18n.revisionDate} : </span><span>{getDate(compteurInfos.revisionDate) || ''}</span>
                        </Grid2>
                    </Grid2>
                </Card>
            </Grid2>
        )
    }

    getPumpCard = (pompeInfos) => {
        const { sandreCodes, classes, variousMaterielTypes } = this.props
        const { selectedMaterial } = this.state
        const pumpNature = variousMaterielTypes.find((t) => t.materielType === pompeInfos.materielType)
        const pumpCategory = getSandreLabel(sandreCodes, 'MAT.MOBILITE', pompeInfos.mobilityCode)
        const pumpType = getSandreLabel(sandreCodes, 'POMPES.TYPE', pompeInfos.pumpType)
        return (
            <Grid2 size={3} className='clickable' style={{ margin: '5px 0' }} onClick={() => this.setSelectedMat(pompeInfos)}>
                <Card className={selectedMaterial === pompeInfos.id ? classes.selected : classes.card}>
                    <Grid2 container>
                        <Grid2 size={12} className='bold'>{i18n.id} : {pompeInfos.reference || ''}</Grid2>
                        <Grid2 size={12} className='margin-bottom-1'>
                            <span className='bold'>{i18n.name} : </span><span>{pompeInfos?.name || ''}</span>
                        </Grid2>
                        <Grid2 size={12}>
                            <span className='bold'>{i18n.nature} : </span><span>{pumpNature ? pumpNature.name : ''}</span>
                        </Grid2>
                        <Grid2 size={12}>
                            <span className='bold'>{i18n.category} : </span><span>{pumpCategory}</span>
                        </Grid2>
                        <Grid2 size={12}>
                            <span className='bold'>{i18n.type} : </span><span>{pumpType}</span>
                        </Grid2>
                        <Grid2 size={12}>
                            <span className='bold'>{i18n.maxFlow} : </span><span>{pompeInfos.maxFlow ? `${pompeInfos.maxFlow} m3/h` : ''}</span>
                        </Grid2>
                        <Grid2 size={12}>
                            <span className='bold'>{i18n.inUseFlow} : </span><span>{pompeInfos.operatingFlow ? `${pompeInfos.operatingFlow} m3/h` : ''}</span>
                        </Grid2>
                    </Grid2>
                </Card>
            </Grid2>
        )
    }

    getCounters = () => {
        const {
            variousMateriels,
            countersIds,
        } = this.props
        return countersIds.map((counterId) => {
            const counterMat = variousMateriels.find((m) => m.id === counterId) || {}
            const counter = counterMat.counter || {}
            const compteurInfos = {
                ...counterMat,
                ...counter,
            }
            return this.getCounterCard(compteurInfos)
        })
    }

    getPumps = () => {
        const {
            variousMateriels,
            pumpsIds,
        } = this.props
        return pumpsIds.map((pumpId) => {
            const pompeMat = variousMateriels.find((m) => m.id === pumpId) || {}
            const pompe = pompeMat.pump || {}
            const pompeInfos = {
                ...pompeMat,
                ...pompe,
            }
            return this.getPumpCard(pompeInfos)
        })
    }

    handleChange = (key, value) => {
        if (key === 'consoType') {
            this.setState({ measureDate: null, endDate: null, value: null })
        }
        this.setState({ [key]: value })
    }

    getChronicles = () => {
        const { chronicles, selectedMaterial, consoType } = this.state
        const { variousMateriels } = this.props
        const matFind = variousMateriels.find((mat) => mat.id === selectedMaterial) || {}
        const filteredChronicles = chronicles.filter((c) => c.idMat === selectedMaterial && c.mode !== 'd' && c.measureType === consoType)
        const data = orderBy(filteredChronicles, ['measureDate', 'endDate'], 'desc').map((chronicle) => {
            const values = consoType === TYPE_ESTIM ? {
                startDate: {
                    value: getDate(chronicle.measureDate),
                },
                endDate: {
                    value: getDate(chronicle.endDate),
                },
                estimateM3: {
                    value: `${formatMilliers(chronicle.value) || 0} m3`,
                },
            } : {
                statementDate: {
                    value: getDate(chronicle.measureDate),
                },
                nullValue: {
                    value: '',
                },
                index: {
                    value: formatMilliers(chronicle.value) || 0,
                },
            }
            return {
                nullValue2: {
                    value: <Icon className='clickable' style={{ color: 'red' }} onClick={() => this.removeChronicle(chronicle.idChronicle)}>delete</Icon>,
                },
                ...values,
            }
        })
        const headers = consoType === TYPE_ESTIM ? headersEstim : headersIndex
        const dataWithHeader = data.length > 0 ? [{ ...data[0], headers: headers.slice(1) }, ...data.slice(1)] : []
        return (
            <CardTable
                title={i18n.consos}
                rows={dataWithHeader}
                rowsPerPageOptions={nbPerPageLabelTiny}
                headers={headers}
                actions={[{
                    icon: 'file_download',
                    color: 'white',
                    tooltip: i18n.export,
                    onClick: () => this.props.export(formatData(dataWithHeader), 'xlsx', `${i18n.consos}_${matFind.reference || ''}`),
                }]}
                color={darkBlue}
            />
        )
    }

    removeChronicle = (idChronicle) => {
        const { chronicles } = this.state
        const newChronicles = [
            ...chronicles.filter((c) => c.idChronicle !== idChronicle),
            {
                ...chronicles.find((c) => c.idChronicle === idChronicle),
                mode: 'd',
            },
        ]
        this.setState({ chronicles: newChronicles })
    }

    addChronicle = () => {
        const {
            measureDate,
            endDate,
            value,
            chronicles,
            selectedMaterial,
            consoType,
        } = this.state
        if (this.checkStep(STEP_CHRONICLE)) {
            const id = chronicles.length ? Math.max(...chronicles.map(c => c.idChronicle)) + 1 : 0
            this.setState({
                chronicles: [
                    ...chronicles,
                    {
                        matType: 'divers',
                        idMat: selectedMaterial,
                        measureType: consoType,
                        measureDate: new Date(measureDate).getTime(),
                        value: value || 0,
                        endDate: consoType === TYPE_ESTIM ? new Date(endDate).getTime() : null,
                        idChronicle: id,
                        new: true,
                    },
                ],
                measureDate: consoType === TYPE_ESTIM ? endDate : '',
                value: '',
                endDate: '',
            })
        }
    }

    getContent = (step) => {
        const { variousMateriels, applicationSettings } = this.props
        const { consoType, measureDate, endDate, value, selectedMaterial } = this.state
        const matFind = variousMateriels.find((mat) => mat.id === selectedMaterial) || {}
        switch (step) {
            case STEP_MATERIEL:
                return (
                    <>
                        <h5>
                            {i18n.selectMaterial}
                        </h5>
                        <Grid2 container spacing={1} alignItems='stretch'>
                            {[...this.getPumps(), ...this.getCounters()]}
                        </Grid2>
                    </>
                )
            case STEP_TYPE:
                const materielsTypeForIndex = getSetting(applicationSettings, 'materielsTypeForIndex')?.split(',').map((id) => Number(id)) || []

                return (
                    <Grid2 container direction='column' spacing={1} className='padding-1'>
                        {materielsTypeForIndex?.includes(matFind.materielType) ? (
                            <Grid2 onClick={() => this.handleChange('consoType', TYPE_INDEX)}>
                                <input className='sieau-input' type='radio' id='index' checked={consoType === TYPE_INDEX} />
                                <label htmlFor='index' className='black-text'>{i18n.indexEntryCounter}</label>
                            </Grid2>
                        ) : (
                            <Grid2 onClick={() => this.handleChange('consoType', TYPE_ESTIM)}>
                                <input className='sieau-input' type='radio' id='estimation' checked={consoType === TYPE_ESTIM} />
                                <label htmlFor='estimation' className='black-text'>{i18n.estimateEntryNoCounter}</label>
                            </Grid2>
                        )}
                    </Grid2>
                )
            case STEP_CHRONICLE:
                return (
                    <>
                        {consoType === TYPE_INDEX && (
                            <Input
                                col={12}
                                title={i18n.readingCoefficient}
                                value={matFind?.counter?.readingCoefficient || ''}
                                readMode
                            />
                        )}
                        <Grid2 container spacing={1} justifyContent='space-between' alignItems='center' className='margin-top-1 margin-bottom-1'>
                            <Grid2 container size={9} spacing={1}>
                                <Grid2 size={4}>
                                    <SimpleDatePicker
                                        id='startDate'
                                        label={consoType === TYPE_ESTIM ? i18n.startDate : i18n.statementDate}
                                        value={measureDate}
                                        max={endDate}
                                        onChange={(v) => this.handleChange('measureDate', v)}
                                        calendarPosition='right'
                                    />
                                </Grid2>
                                {consoType === TYPE_ESTIM && (
                                    <Grid2 size={4}>
                                        <SimpleDatePicker
                                            id='endDate'
                                            label={i18n.endDate}
                                            min={measureDate}
                                            value={endDate}
                                            onChange={(v) => this.handleChange('endDate', v)}
                                            calendarPosition='right'
                                        />
                                    </Grid2>
                                )}
                                <Grid2 size={4}>
                                    <Input
                                        id='value'
                                        title={consoType === TYPE_ESTIM ? i18n.estimateM3 : i18n.index}
                                        type='number'
                                        value={value}
                                        onChange={(v) => this.handleChange('value', parseInt(v))}
                                    />
                                </Grid2>
                            </Grid2>
                            <Grid2 size={3}>
                                <Button variant='contained' color='primary' onClick={this.addChronicle} style={{ width: '100%' }}>
                                    {i18n.add}
                                </Button>
                            </Grid2>
                        </Grid2>
                        {this.getChronicles()}
                    </>
                )
            default:
                return ''
        }
    }

    formatListChronicles = (chronicles) => {
        return chronicles.map((c) => {
            if (c.new) {
                return {
                    ...c,
                    idChronicle: null,
                }
            }
            return c
        })
    }

    onSave = () => {
        const { chronicles } = this.state
        this.props.onSave(this.formatListChronicles(chronicles))
    }

    onCancel = () => {
        this.setState({
            chronicles: [],
            measureDate: '',
            value: '',
            endDate: '',
        })
        this.props.onCancel()
    }

    render() {
        const { open, variousMateriels } = this.props
        const { step, selectedMaterial } = this.state
        const reference = step === STEP_CHRONICLE ? ` : ${(variousMateriels.find((mat) => mat.id === selectedMaterial) || {}).reference}` : ''
        return (
            <Dialog
                maxWidth='md'
                open={open}
            >
                <DefaultDialogTitle
                    title={`${i18n.consosEntry}${reference}`}
                    onClose={this.onCancel}
                />
                <DialogContent>
                    {this.getContent(step)}
                </DialogContent>
                <DialogActions style={{ justifyContent: 'space-between' }}>
                    <Button variant='outlined' color='primary' onClick={this.onCancel}>
                        {i18n.cancel}
                    </Button>
                    <Button
                        variant='outlined'
                        color='primary'
                        onClick={this.previousStep}
                        disabled={step === 0}
                    >
                        {i18n.previous}
                    </Button>
                    <Button
                        variant='outlined'
                        color='primary'
                        onClick={this.nextStep}
                        disabled={step === STEP_CHRONICLE}
                    >
                        {i18n.next}
                    </Button>
                    <Button
                        variant='contained'
                        color='primary'
                        onClick={this.onSave}
                        disabled={step !== STEP_CHRONICLE}
                    >
                        {i18n.validate}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

AddConsoModal.propTypes = {
    classes: PropTypes.instanceOf(PropTypes.object),
    onSave: PropTypes.func,
    onCancel: PropTypes.func,
    export: PropTypes.func,
    open: PropTypes.bool,
    chronicles: PropTypes.arrayOf(PropTypes.instanceOf(DtoMaterielChronicle)),
    sandreCodes: PropTypes.arrayOf(PropTypes.instanceOf(DtoSandreCode)),
    variousMaterielTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoVariousMaterielType)),
    variousMateriels: PropTypes.arrayOf(PropTypes.instanceOf(VariousMaterielDto)),
    variousMaterielsLastSituations: PropTypes.arrayOf(PropTypes.instanceOf(DtoVariousMaterielSituation)),
    applicationSettings: PropTypes.arrayOf(PropTypes.instanceOf(SieauParameterDto)),
    pumpsIds: PropTypes.arrayOf(PropTypes.number),
    countersIds: PropTypes.arrayOf(PropTypes.number),
    selectedMaterial: PropTypes.number,
    consoType: PropTypes.number,
    warning: PropTypes.func,
}

const mapStateToProps = (store) => {
    return {
        exploitation: store.AgriReducer.exploitation,
        variousMateriels: store.VariousMaterielReducer.variousMateriels,
        variousMaterielsLastSituations: store.VariousMaterielReducer.variousMaterielsLastSituations,
        variousMaterielTypes: store.VariousMaterielReducer.variousMaterielTypes,
        sandreCodes: store.ReferencialReducer.sandreCodes,
        applicationSettings: store.AdministrationReducer.applicationSettings,
    }
}

const mapDispatchToProps = {
    warning: ToastrAction.warning,
    export: ExportAction.export,
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddConsoModal))
